var GALLERY_TEXT_ALIGN = {
    LEFT: 'left',
    RIGHT: 'right',
    CENTER: 'center',
};
export default GALLERY_TEXT_ALIGN;
//# sourceMappingURL=galleryTextAlign.js.map